import { render, staticRenderFns } from "./VehiclesSelectorSidebar.vue?vue&type=template&id=56d0e062&scoped=true"
import script from "./VehiclesSelectorSidebar.vue?vue&type=script&lang=js"
export * from "./VehiclesSelectorSidebar.vue?vue&type=script&lang=js"
import style0 from "./VehiclesSelectorSidebar.vue?vue&type=style&index=0&id=56d0e062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0e062",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Label: require('/app/components/Label.vue').default,LedSearchFormLicencePlate: require('/app/components/LedSearchFormLicencePlate.vue').default,LedSearchFormVehicles: require('/app/components/LedSearchFormVehicles.vue').default,VehicleSelectionModal: require('/app/components/VehicleSelectionModal.vue').default})
